import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { storeChat } from "../../Services/Redux/Reducers/chatSlice";
import { loader } from "../../Services/Redux/Reducers/commonSlice";
import { getTitle } from "../../Services/CommonServices/helper";
import Typewriter from "../../CommonComponents/TypeWriting";
import { ProductListingGridProps } from "../../Services/CommonServices/propTypes";
import { useLocation } from "react-router-dom";
import { brandMap } from "../../Services/BrandName";

function ProductListingGrid(props) {
  const dispatch = useDispatch();
  const conList = useSelector((state) => state.chat.conversationList);
  const loading = useSelector((state) => state.common.isLoader);
  const [isOverviewTextLoading, setIsOverviewTextLoading] = useState(false);
  const [isLuxeDesc, setIsLuxeDesc] = useState(false);
  const [isConclusionLoading, setIsConclusionLoading] = useState(false);
  const [isiOS, setiOS] = useState(false);
  // const [isLuxeFirst] = props.products;

  function formatBrands(brands) {
    if (brands?.length === 0) return "";
    if (brands?.length === 1) return brands[0];

    return (
      brands?.slice(0, -1).join(", ") +
      " and " +
      brands[brands?.length - 1]
    );
  }
  
  function processData(arr) {
    // ✅ check presence
    const hasTrue = arr?.some(item => item.isLuxe === true);
    const hasFalse = arr?.some(item => item.isLuxe === false);

    const hasBoth = hasTrue && hasFalse;

    let brands = "";

    if (hasBoth) {
      // ✅ ONLY take isLuxe = true
      const luxeBrands = arr?.filter(item => item.isLuxe === true)?.map(item => item.brandName);

      // ✅ remove duplicates
      const uniqueBrands = [...new Set(luxeBrands)];
      const brandNameMapped = uniqueBrands?.map(brand => brandMap[brand] || brand);
      
      // ✅ format string
      brands = formatBrands(brandNameMapped);
    }

    return {
      hasMixedIsLuxe: hasBoth,
      brands,
    };
  }


  const isStopTriggered = useSelector(
    (state) => state.chat.isStopButtonTriggered
  );
  const location = useLocation();
 
  const handleClick = (product, type) => {
    if (!loading) { 
      if (type === "search") {
        let data = {
          text: "Show me details for the " + getTitle(product) + ".",
          query: "Can you please show me product ID " + product.id + " color " + product.color + "?",
          type: type,
        };
        if (!props.stopClick) {
          props?.onValueChange(data);
        }
      }
    }
  };
 
  useEffect(() => {
    if (
      props.index === conList?.length - 1 &&
      props.isAnswerComplete &&
      !isStopTriggered &&
      loading
    ) {
      if (
        props.text !== null &&
        isOverviewTextLoading === true &&
        (props.products === undefined ||
          props.products?.length === 0 ||
          props.products) &&
        (props.conclusion === undefined ||
          props.conclusion === "" ||
          (props.conclusion &&
            props.conclusion !== "" &&
            isConclusionLoading === true))
      ) {
        dispatch(storeChat(true));
        dispatch(loader(false));
      }
    }
    if (isStopTriggered && !isOverviewTextLoading && !isConclusionLoading) {
      dispatch(loader(true));
    }
  }, [
    props.conclusion,
    props.isAnswerComplete,
    props.products,
    props.text,
    isOverviewTextLoading,
    isConclusionLoading,
    loading,
  ]);
 
  const getSCImage = (img) => {
    let selectedImage = [];
    selectedImage =
      img &&
      img?.length > 0 &&
      img?.filter((item) => item.type === "PrimaryImage");
    if(selectedImage?.length === 0) 
      selectedImage = img &&
      img?.length > 0 &&
      img?.filter((item) => item.type === "Image");

    return (
      <button name="productImage" className="brandingcss p-0 border-0 bg-transparent">
        {selectedImage && selectedImage?.length > 0 && (
          <img
            className="img-res"
            src={
              selectedImage[0].url !== ""
                ? selectedImage[0].url?.split("?fmt=webp-alpha")[0] +
                  "?$rl_4x5_pdp$&fmt=webp-alpha"
                : "./static/assets/no-image.png"
            }
            alt="no img"
          />
        )}
      </button>
    );
  };
 
  useEffect(() => {
    let userAgent = window.navigator.userAgent.toLowerCase(),
        iosPlatforms = /iPad|iPhone|iPod/i;
    if (iosPlatforms.test(userAgent)) {
      setiOS(true);
    }
  }, []);
 
  return (
    <div>
      { (props.text || props.products || props.conclusion) &&
        <div className={`listing-card card ${(props.products?.length === 0 && isiOS) && 'marginbottom'}`}>
          <div className="card-body p-0 ">
            <div className={`card-text`}>
              <Typewriter
                convoId={props.convoId}
                text={props.text}
                type="responseText"
                delay={props.delay}
                isAnswerComplete={props.isAnswerComplete}
                setLoading={setIsOverviewTextLoading}
                effects={props.effects}
              />
            </div>
            {((props.index !== conList?.length - 1 &&
              props.products &&
              props.products?.length > 0) ||
              ((props.text === "" || isOverviewTextLoading) &&
                props.products &&
                props.products?.length > 0)) && (
              <>
                <div
                  className={`row bs_gutter grid-mt`}
                >
                  {/* {
                    isLuxeFirst.isLuxe === true ? (
                      <>
                        {props.products?.map((products, index) => (
                          <>
                            {
                              products.isLuxe === true && (
                                <div
                                  key={products.id || `product-${index}`}
                                  className="col-6 col-sm-6 col-md-4 col-lg-4"
                                >
                                <div
                                  className="products"
                                  onClick={() => {
                                    if(location.pathname !== '/chathistory') {
                                      handleClick(products, "search");
                                    }
                                  }}
                                >
                                <div className="d-flex sc-img-div img-bg">
                                  {getSCImage(products.media)}
                                </div>
                                </div>
                              </div>
                                )
                              }
                            </>
                          ))}
                        <div className={`card-text ` + "split_text_spacing"}>
                          <Typewriter
                            convoId={props.convoId}
                            text={props.text}
                            type="responseText"
                            delay={props.delay}
                            isAnswerComplete={props.isAnswerComplete}
                            setLoading={setIsOverviewTextLoading}
                            effects={props.effects}
                          />
                        </div>
                        {props.products?.map((products, index) => (
                          <>
                            {
                              products.isLuxe === false && (
                              <div
                                key={products.id || `product-${index}`}
                                className="col-6 col-sm-6 col-md-4 col-lg-4"
                              >
                                <div
                                  className="products"
                                  onClick={() => {
                                    if(location.pathname !== '/chathistory') {
                                      handleClick(products, "search");
                                    }
                                  }}
                                >
                                <div className="d-flex sc-img-div img-bg">
                                  {getSCImage(products.media)}
                                </div>
                                </div>
                              </div>
                              )
                            }
                          </>
                        ))}
                      </>
                    ) : ( */}
                    {
                      processData(props.products)?.hasMixedIsLuxe ?
                      <>
                        {props.products?.map((products, index) => (
                          <React.Fragment key={products.id || `product-${index}`}>
                            {
                              products.isLuxe === false && (
                              <div
                                className="col-6 col-sm-6 col-md-4 col-lg-4"
                              >
                              <div
                                className="products"
                                onClick={() => {
                                  if(location.pathname !== '/chathistory') {
                                    handleClick(products, "search");
                                  }
                                }}
                              >
                                <div className="d-flex sc-img-div img-bg">
                                  {getSCImage(products.media)}
                                </div>
                              </div>
                            </div>
                              )
                            }
                          </React.Fragment>
                        ))}
                        {
                          processData(props.products)?.hasMixedIsLuxe && processData(props.products)?.brands && (
                            <div className={`card-text ` + "split_text_spacing"}>
                              <Typewriter
                                convoId={props.convoId}
                                text="If craftsmanship and details are top of mind, here are a few additional selections."
                                // text={processData(props.products)?.brands && `Here are some luxury selections from the ${processData(props.products)?.brands}.`}
                                type="responseText"
                                delay={props.delay}
                                isAnswerComplete={props.isAnswerComplete}
                                setLoading={setIsLuxeDesc}
                                effects={props.effects}
                              />
                            </div>
                          )
                        }
                        
                        {isLuxeDesc && props.products?.map((products, index) => (
                          <React.Fragment key={products.id || `product-${index}`}>
                            {
                              products.isLuxe === true && (
                                <div
                                  className="col-6 col-sm-6 col-md-4 col-lg-4"
                                >
                                <div
                                  className="products"
                                  onClick={() => {
                                    if(location.pathname !== '/chathistory') {
                                      handleClick(products, "search");
                                    }
                                  }}
                                >
                                <div className="d-flex sc-img-div img-bg">
                                  {getSCImage(products.media)}
                                </div>
                                </div>
                               </div>
                               )
                            }
                          </React.Fragment>
                        ))}
                      </>
                      :
                      <>
                        {props.products?.map((products, index) => (
                          <React.Fragment key={products.id || `product-${index}`}>
                            {
                              products.isLuxe === false && (
                              <div
                                className="col-6 col-sm-6 col-md-4 col-lg-4"
                              >
                              <div
                                className="products"
                                onClick={() => {
                                  if(location.pathname !== '/chathistory') {
                                    handleClick(products, "search");
                                  }
                                }}
                              >
                                <div className="d-flex sc-img-div img-bg">
                                  {getSCImage(products.media)}
                                </div>
                              </div>
                            </div>
                              )
                            }
                          </React.Fragment>
                        ))}
                        
                        {props.products?.map((products, index) => (
                          <>
                            {
                              products.isLuxe === true && (
                                <div
                                  key={products.id || `product-${index}`}
                                  className="col-6 col-sm-6 col-md-4 col-lg-4"
                                >
                                <div
                                  className="products"
                                  onClick={() => {
                                    if(location.pathname !== '/chathistory') {
                                      handleClick(products, "search");
                                    }
                                  }}
                                >
                                <div className="d-flex sc-img-div img-bg">
                                  {getSCImage(products.media)}
                                </div>
                                </div>
                              </div>
                              )
                            }
                          </>
                        ))}
                      </>
                    }
                    {/* )
                  } */}
                </div>
              </>
            )}
            {(props.index === conList?.length - 1 && loading) && (
              <div className="loading-gif">
                <img
                     src="/static/assets/InLine.gif"
                     alt="dot"        
                     className="inline-gif"        
                  />
              </div>
            )}
            {((props.index !== conList?.length - 1 &&
              props.conclusion &&
              props.conclusion !== "") ||
              (((props.product?.length === 0 && isOverviewTextLoading) ||
                props.products) &&
                props.conclusion)) && (
              <div className={`card-text mb-3 card-conclusion-mt`}>
                <Typewriter
                  type="responseConclusion"
                  convoId={props.convoId}
                  text={props.conclusion ?? ""}
                  delay={props.delay}
                  isAnswerComplete={props.isAnswerComplete}
                  setLoading={setIsConclusionLoading}
                  effects={props.effects}
                />
              </div>
            )}
          </div>
        </div>
      }
    </div>
  );
}

ProductListingGrid.propTypes = ProductListingGridProps;
export default ProductListingGrid;
